import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import Translation from '../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { validateEmail } from '../../../../../utils/validation.utils';
import {
    ORFButton
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_InputField as InputField
} from '../../../../common/forms/order-request-form.component';
import { Row, Col } from 'react-bootstrap';
import Icons from '../../../../icon';
import { trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import { wirelineOtherRequestActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-other-request.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../common/file-attachment/file-attachment.component';

class WirelineOtherForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localToggle: false,
            alterToggle: false,
        }
    }

    componentDidMount() {
        this.props.fetchOtherOptions();
    }

    componentWillUnmount() {
        this.props.resetWirelineOtherRequestForm();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems, uploadFile, saveOrderFile } = this.props;

        var success = await submitRequest();
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //form
            wirelineOtherRequestFormA
            //reducer action
            , onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
            , onChangeExpedite
        } = this.props;

        const { subscriptionList, employeeList, takeActionCircuitCode } = this.props.createRequest;
        const { otherOptions, formSubmitted, subscription } = this.props.wirelineOtherRequestRequest;

        let expediteOptions = [
            {
                "Key": true,
                "Value": "Yes"
            },
            {
                "Key": false,
                "Value": "No"
            }
        ];

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineOtherRequestFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineOtherRequestFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')} *`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                            />
                            {wirelineOtherRequestFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                    {subscription.PlanName} <span>&#8226;</span> {subscription.VendorName} <span>&#8226;</span> {subscription.SimName}
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('Request')} *`}
                                value={wirelineOtherRequestFormA.otherRequestTypeId}
                                options={otherOptions}
                                placeholder={this.toLocaleLanguage('select_a_request')}
                                fieldProp='.otherRequestTypeId'
                                disabled={wirelineOtherRequestFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineOtherRequestFormA.employeeEmail}
                                label={`${this.toLocaleLanguage('approver')} *`}
                                propDisplay={'Name'}
                                options={employeeList.length > 0 ? employeeList : ''}
                                onChangeAction={onEmployeeSelect}
                                searchAction={fetchEmployeeByValue}
                                disabled={wirelineOtherRequestFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                        <Icons
                            customClassName="icon-circle-plus"
                            name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                            size="20px"
                            containerClass="icon-circle-plus-container"
                        />
                        <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                    </div>
                    {this.state.localToggle ?
                        <div className="local-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                        value={wirelineOtherRequestFormA.localContactEmail}
                                        fieldProp='.localContactEmail'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                        value={wirelineOtherRequestFormA.localContactFullName}
                                        fieldProp='.localContactFullName'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                        value={wirelineOtherRequestFormA.localContactPhone}
                                        fieldProp='.localContactPhone'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>
                        : ""}
                    <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                        <Icons
                            customClassName="icon-circle-plus"
                            name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                            size="20px"
                            containerClass="icon-circle-plus-container"
                        />
                        <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                    </div>
                    {this.state.alterToggle ?
                        <div className="alter-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                        value={wirelineOtherRequestFormA.altLocalContactEmail}
                                        fieldProp='.altLocalContactEmail'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_full_name')} *`}
                                        value={wirelineOtherRequestFormA.altLocalContactFullName}
                                        fieldProp='.altLocalContactFullName'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_phone_number')} *`}
                                        value={wirelineOtherRequestFormA.altLocalContactPhone}
                                        fieldProp='.altLocalContactPhone'
                                        disabled={wirelineOtherRequestFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>

                        : ""}
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('expedite_request')} *`}
                                value={wirelineOtherRequestFormA.expediteRequest}
                                onChangeAction={onChangeExpedite}
                                options={expediteOptions}
                                fieldProp='.expediteRequest'
                                disabled={wirelineOtherRequestFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')} *`}
                                fieldProp='.businessJustification'
                                value={wirelineOtherRequestFormA.businessJustification}
                                disabled={wirelineOtherRequestFormA.circuitId == 0 || !trueFalseToBoolean(wirelineOtherRequestFormA.expediteRequest)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineOtherRequestFormA.additionalInformation}
                                disabled={wirelineOtherRequestFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <FileAttachment />
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={wirelineOtherRequestFormA.circuitId == 0
                                        || wirelineOtherRequestFormA.wireLineApproverId == 0
                                        || wirelineOtherRequestFormA.otherRequestTypeId == ''

                                        || wirelineOtherRequestFormA.localContactEmail == ''
                                        || !validateEmail(wirelineOtherRequestFormA.localContactEmail)
                                        || wirelineOtherRequestFormA.localContactFullName == ''
                                        || wirelineOtherRequestFormA.localContactPhone == ''

                                        || wirelineOtherRequestFormA.altLocalContactEmail == ''
                                        || !validateEmail(wirelineOtherRequestFormA.altLocalContactEmail)
                                        || wirelineOtherRequestFormA.altLocalContactFullName == ''
                                        || wirelineOtherRequestFormA.altLocalContactPhone == ''

                                        || (trueFalseToBoolean(wirelineOtherRequestFormA.expediteRequest) && wirelineOtherRequestFormA.businessJustification == '')
                                        || formSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelineOtherRequestRequest, createRequest, translation } = state;
        const { wirelineOtherRequestFormA } = state.form;
        return {
            wirelineOtherRequestRequest
            , wirelineOtherRequestFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineOtherRequestActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
            ),
            dispatch
        )
)(WirelineOtherForm);